module.exports = __webpack_public_path__ + "static/media/pouch-pass-logo.10196f5c.svg";